import e from "react";
import { translate as r } from "@aws-amplify/ui";
import { Button as t } from "../../../primitives/Button/Button.js";
import { Flex as o } from "../../../primitives/Flex/Flex.js";
import { View as n } from "../../../primitives/View/View.js";
import { FederatedSignIn as i } from "../FederatedSignIn/FederatedSignIn.js";
import { useAuthenticator as m } from "../hooks/useAuthenticator/index.js";
import { useCustomComponents as l } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as a } from "../hooks/useFormHandlers/useFormHandlers.js";
import { RemoteErrorMessage as s } from "../shared/RemoteErrorMessage.js";
import { FormFields as u } from "../shared/FormFields.js";

function d() {
  var _m = m(function (e) {
    return [e.hasValidationErrors, e.isPending];
  }),
      u = _m.hasValidationErrors,
      c = _m.isPending,
      _a = a(),
      p = _a.handleChange,
      f = _a.handleBlur,
      F = _a.handleSubmit,
      _l = l(),
      _l$components$SignUp = _l.components.SignUp,
      _l$components$SignUp$ = _l$components$SignUp.Header,
      h = _l$components$SignUp$ === void 0 ? d.Header : _l$components$SignUp$,
      _l$components$SignUp$2 = _l$components$SignUp.FormFields,
      E = _l$components$SignUp$2 === void 0 ? d.FormFields : _l$components$SignUp$2,
      _l$components$SignUp$3 = _l$components$SignUp.Footer,
      g = _l$components$SignUp$3 === void 0 ? d.Footer : _l$components$SignUp$3;

  return e.createElement(n, null, e.createElement(h, null), e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-signup": "",
    method: "post",
    onChange: p,
    onSubmit: F,
    onBlur: f
  }, e.createElement(i, null), e.createElement(o, {
    as: "fieldset",
    direction: "column",
    isDisabled: c
  }, e.createElement(o, {
    direction: "column"
  }, e.createElement(E, null), e.createElement(s, null)), e.createElement(t, {
    isDisabled: u || c,
    isFullWidth: !0,
    type: "submit",
    variation: "primary",
    isLoading: c,
    loadingText: r("Creating Account")
  }, r("Create Account")))), e.createElement(g, null));
}

d.Header = function () {
  return null;
}, d.FormFields = function () {
  return e.createElement(u, null);
}, d.Footer = function () {
  return null;
};
export { d as SignUp };